var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleColored(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 524"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.8 10.2222C19.8 9.39995 19.7332 8.79995 19.5888 8.17773H10.2V11.8888H15.711C15.6 12.8111 15 14.1999 13.6666 15.1332L13.6479 15.2575L16.6165 17.5572L16.8222 17.5777C18.711 15.8333 19.8 13.2666 19.8 10.2222Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.2 20C12.8999 20 15.1666 19.1111 16.8222 17.5778L13.6666 15.1333C12.8222 15.7222 11.6888 16.1333 10.2 16.1333C7.55553 16.1333 5.31111 14.3889 4.51103 11.9778L4.39376 11.9877L1.30697 14.3766L1.2666 14.4889C2.91103 17.7555 6.28882 20 10.2 20Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.51102 11.9778C4.29991 11.3555 4.17774 10.6888 4.17774 9.99997C4.17774 9.31104 4.29991 8.6444 4.49991 8.02219L4.49432 7.88967L1.36885 5.4624L1.26659 5.51104C0.588844 6.86662 0.199951 8.38887 0.199951 9.99997C0.199951 11.6111 0.588844 13.1333 1.26659 14.4888L4.51102 11.9778Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.2 3.86664C12.0777 3.86664 13.3443 4.67775 14.0666 5.35557L16.8888 2.6C15.1555 0.988893 12.8999 0 10.2 0C6.28882 0 2.91103 2.24443 1.2666 5.51107L4.49992 8.02221C5.31111 5.61111 7.55553 3.86664 10.2 3.86664Z",
    fill: "#EB4335"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleColored);
export default __webpack_public_path__ + "static/media/google-colored.fe11022d9f0c144f2f0f1618858b4e19.svg";
export { ForwardRef as ReactComponent };